<template>
  <div class="upload-m">
    <el-upload
      class="avatar-uploader"
      ref="upload"
      action=""
      :http-request="handleUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      :show-file-list="false"
    >
      <div class="pictrue-img-box">
        <img v-if="urls" :src="urls" class="avatar" @mouseover="mask = true" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>

        <div
          v-if="mask"
          class="pictrue-img-box-mask"
          @mouseover="mask = true"
          @mouseout="mask = false"
          @click.stop="
            () => { 
              return false;
            }
          "
        >
          <i
            class="el-icon-zoom-in"
            @click.stop="handlePreview({ url: imageUrl })"
          ></i>
          <i class="el-icon-delete" @click.stop="handleRemove(imageUrl)"></i>
        </div>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" style="z-index: 1999">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 图片裁剪对话框 -->
    <el-dialog
      title="图片裁剪"
      width="70%"
      :visible.sync="cropperVisible"
      :close-on-click-modal="false"
    >
      <div class="cropper-box" :style="{height: height + 'px'}">
        <vueCropper
          ref="cropper"
          :img="cropperImg"
          :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
        ></vueCropper>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropperVisible = false">取消</el-button>
        <el-button type="primary" @click="cropImage">确定裁剪</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadOSS } from "@/utils/oss";
import { VueCropper } from 'vue-cropper'
export default {
  name: "Upload",
  components: {
    VueCropper,
  },
  data() {
    return {
      imageUrl: "",
      dialogImageUrl: "",
      dialogImageUrl1: "",
      dialogVisible: false,
      mask: false,
      urls: "",
      srcList: [],
      uploadType: "oss",//判断是本地上传  "local" 或 oss 直传 "oss",
      cropperVisible: false,
      cropperImg: '',
      tempFile: null,
      option: {
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: false,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        autoCropWidth: 230,  //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [1.53, 1], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: false,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 2,          //图片根据截图框输出比例倍数
        mode: '230px 150px'  //图片默认渲染方式
      }
    };
  },

  props: {
    url: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 700,
    },
    height: {
      type: Number,
      default: 1000,
    },
  },
  created() { 
    this.option.autoCropWidth = this.width;
    this.option.autoCropHeight = this.height;
    this.option.mode = this.width + 'px ' + this.height + 'px';
    this.option.fixedNumber = [this.width / this.height, 1];
  },
  mounted() { 
  },
  watch: {
    src: {
      immediate: true,
      handler(e, r) {
        this.srcList = [];
        this.dialogImageUrl1 = e;
        this.urls = e;
        this.srcList.push(e);
      },
    },
  },
  methods: {
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    beforeAvatarUpload(file){
        const isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
        if (!isJPG) {
          this.$message.error('请上传正确的图片格式！');
        }
        return isJPG
    },
    // 打开裁剪对话框
    openCropper(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperImg = e.target.result;
        this.tempFile = file;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);
    },
    // 裁剪图片
    cropImage() {
      this.$refs.cropper.getCropBlob((blob) => {
        // 创建新的File对象用于上传
        const croppedFile = new File([blob], this.tempFile.name, {
          type: blob.type
        });
        this.cropperVisible = false;
        // 调用上传方法
        this.performUpload(croppedFile);
      }, 'image/png', 1);
    },
    handleUpload({ file }) {
      // 打开裁剪对话框
      this.openCropper(file);
    },
    performUpload(file) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (this.uploadType == "oss") {
          console.log("oss");
          uploadOSS(file).then((res) => {
            if (res) {
              this.imageUrl = res;
              this.urls = res;
              this.$emit("update:url", this.imageUrl);
            } else {
              this.$message.warning("上传失败，请重试");
            }
            loading.close();
          });
        }else{
          var formData = new FormData();
          formData.append("file",file);
          formData.append("moduleName", "img");
          this.$Apis.verificationImg(formData).then(res=>{
            if(res.code == 200){
              this.imageUrl =  res.data;
              this.urls =  res.data;
              this.$emit("update:url", this.imageUrl);
            }else{
              this.$message.warning(res.msg);
            }
            
            loading.close();
          })
        }
      } catch (error) {}
    },
    handlePreview(file) {
      if (file.url == "") {
        this.dialogImageUrl = this.dialogImageUrl1;
      } else {
        this.dialogImageUrl = file.url;
      }
      this.dialogVisible = true;
    },
    handleRemove() {
      this.imageUrl = "";
      this.urls = "";
      this.$emit("update:url", "");
    },
  },
};
</script>

<style lang="scss">
.v-modal {
  z-index: 2000 !important;
}
.upload-m {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
  .pictrue-img-box {
    position: relative;
    .pictrue-img-box-mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: space-around;
      align-items: center;
      i {
        font-size: 20px;
        color: #fff;
      }
    }
  }
}
.cropper-box {
  width: 100%;
  height: auto;
}

</style>